module.exports = __webpack_public_path__ + "static/media/add-section.7db7906b.svg";